import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from './StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'

const OfficeAvailabilityCheck = ({ selectedOffices }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (!!selectedOffices && selectedOffices.length > 0) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [selectedOffices])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'optional' : 'none'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('articleAdmin:activateArticleForUnits')}</span>
    </>
  )
}

export default OfficeAvailabilityCheck